import { cx } from '@platform/core/lib/cx';
import type { IFormSwitchCardProps } from './IFormSwitchCardProps';

/**
 * Картка перемикачів редактора форми (прототип v4 feTop / feTabs): акцентний заголовок великими літерами, примітка, рядки з підписом і
 * перемикачем 42×24; клік перемикає й одразу зберігає форму простору (без можливості customize — вимкнено).
 */
export function FormSwitchCard({ title, note, items, disabled }: IFormSwitchCardProps) {
  return (
    <section className="st-card st-fe">
      <span className="st-kicker">{title}</span>
      {note && <div className="st-fe__note">{note}</div>}
      <div className="st-fe__list">
        {items.map((x) => (
          <div key={x.key} className="st-fe__row">
            <span className="st-fe__label">{x.label}</span>
            <button type="button" role="switch" aria-checked={x.on} aria-label={x.label} disabled={disabled} className={cx('st-switch', x.on && 'is-on')} onClick={x.onToggle}><span /></button>
          </div>
        ))}
      </div>
    </section>
  );
}
